const mFeedSectionContentCardDesing2 = {
  mFeedSectionContentCardDesing2: {
    available: 'Disponible',

    assetIncluded: {
      adding: 'Incluyendo',
      included: 'Incluido',
      notIncluded: 'No Incluido',
      removing: 'Quitando'
    },

    draft: 'Borrador',
    hidden: 'Oculto',
    noCategoryName: 'Sin Categoría',
    noprice: 'Sin Precio',
    notAvailable: 'No Disponible',

    price: {
      buy: 'COMPRAR',
      free: 'GRATIS'
    },

    published: 'Publicado',
    selected: 'Seleccionada',
    tooltipEnrolled: 'Alumnos Inscriptos',
    tooltipMessages: 'Mensajes Pendientes',
    visible: 'Visible'
  }
}

export default mFeedSectionContentCardDesing2
